import React from "react";
import { Stack, Typography } from "@mui/material";

import { HubSideBar, HubTableTemplate } from "../../components";
import { SubRoutesTable } from "../../tables";

const LaborSubroutes = ({ routeId }) => {
  return (
    <HubSideBar maxWidth="100%" gap="25px">
      <Stack
        width="100%"
        sx={{ ".MuiTypography-root": { justifyContent: "start" } }}
      >
        <Stack direction="row" gap="5px" alignItems="center">
          <Typography variant="boldCaptionMainL" sx={{ fontSize: "14px" }}>
            Rework for this Route
          </Typography>
          <Typography variant="boldCaption" sx={{ fontSize: "14px" }}>
            (Retrabajo Para Esta Ruta)
          </Typography>
        </Stack>
        <Stack direction="row" gap="5px" alignItems="center">
          <Typography variant="caption">
            All rework is seperated by group
          </Typography>
          <Typography
            variant="caption"
            sx={{ color: "hubColors.mainFocus", fontWeight: 600 }}
          >
            (Todas las piezes estan separado por grupo)
          </Typography>
        </Stack>
      </Stack>
      <SubRoutesTable routeId={routeId} isSmall />
    </HubSideBar>
  );
};

export default LaborSubroutes;
